// @flow
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {compose, lifecycle} from 'recompose'

import AdminAMList from '../components/AdminAMList/AdminAMList'
import * as actions from '../actions'

import type {MapStateToProps, MapDispatchToProps} from 'react-redux'
import type {State, Action} from 'modules/Common/types'
import type {AdminState} from '../types/index'

export type StateProps = {
  accountManagers: $PropertyType<AdminState, 'accountManagers'>,
  companies: $PropertyType<AdminState, 'companies'>,
  isLoadingAccountManagers: $PropertyType<AdminState, 'isLoadingAccountManagers'>,
  isInvitingAM: $PropertyType<AdminState, 'isInvitingAM'>,
  error: $PropertyType<AdminState, 'error'>,
  isLoadingCompaniesSuggestion: $PropertyType<AdminState, 'isLoadingCompaniesSuggestion'>,
  companiesSuggestion: $PropertyType<AdminState, 'companiesSuggestion'>
};

export type OwnProps = {
  companyId?: ?string,
  isSubScreen?: boolean,
  companyName?: string
};

export type DispatchProps = {
  getAccountManagers: $PropertyType<typeof actions, 'getAccountManagers'>,
  getCompanies: $PropertyType<typeof actions, 'getCompanies'>,
  addOrUpdateAM: $PropertyType<typeof actions, 'addOrUpdateAM'>,
  getCompaniesSuggestion: $PropertyType<typeof actions, 'getCompaniesSuggestion'>
};

const mapStateToProps: MapStateToProps<State, OwnProps, StateProps> = state => {
  return {
    accountManagers: state.admin.accountManagers,
    isLoadingAccountManagers: state.admin.isLoadingAccountManagers,
    companies: state.admin.companies,
    isInvitingAM: state.admin.isInvitingAM,
    error: state.admin.error,
    isLoadingCompaniesSuggestion: state.admin.isLoadingCompaniesSuggestion,
    companiesSuggestion: state.admin.companiesSuggestion
  }
}

const mapDispatchToProps: MapDispatchToProps<Action<*>, OwnProps, DispatchProps> = dispatch => bindActionCreators({...actions}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {}
  })
)(AdminAMList)
